import React from 'react'
import styled from 'styled-components'

// Constants
import { tableCellStyles } from '../../../_constants/styles'
import { S_ControlsButton } from '../../ControlsButton'

export const staticCell = {
  rowNumberWidth: '35px',
}

export const S_StaticCell = styled.div`
  ${tableCellStyles}

  &.row-number {
    flex: 0 1 ${staticCell.rowNumberWidth}; /* Will fit values up to 10000 */
    max-width: ${staticCell.rowNumberWidth};
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #999;
  }

  &.row-controls {
    flex-grow: 0;
    justify-content: center;
    ${S_ControlsButton} {
      width: 20px;
      height: 20px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
`

/**
 * Literally just render the children, add standard styles
 * @param {*} param0
 */
export const StaticCell = (props) => {
  const { children, ...rest } = props
  return <S_StaticCell {...rest}>{children}</S_StaticCell>
}
